// extracted by mini-css-extract-plugin
export default {"tradeScreenshots":"trade-screenshots_tradeScreenshots__h8Iy9","screenshot":"trade-screenshots_screenshot__hCnaT"};